import { ReactSVG } from 'react-svg';
import styled from 'styled-components';

export const WarningIcon = styled(ReactSVG)`
  margin-right: 15px;`;

interface WarningWrapperProps {
  fullWidth: boolean;
}

export const WarningWrapper = styled.div<WarningWrapperProps>`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
  margin: 10px 0px;
  padding: 5px 15px;
  border: 1px solid ${({ theme }) => theme.elements.primaryMedium};
  border-radius: 5px;
`;

export const WarningContent = styled.div`
  display: flex;
  align-items: center;
`;

export const WarningText = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Message = styled.span`
  font-weight: 600;
`;
